import { render, staticRenderFns } from "./SlideTypeListV2.vue?vue&type=template&id=53fd8b63&"
import script from "./SlideTypeListV2.vue?vue&type=script&lang=js&"
export * from "./SlideTypeListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports